import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import requestUtil from '../../helpers/requestUtil';
import useConfiguration from '../../hooks/useConfiguration';
import useSessionStorage from '../../hooks/useSessionStorage';
import useValidation from '../../hooks/useValidation';
import Loader from '../common/Loader';
import {
  setLoadingPageFalse,
  setLoadingPageTrue,
} from '../common/Loader/action';
import Error from '../common/Message/error';
import Success from '../common/Message/success';
import TextField from '../common/TextField';
//import { loginSelector } from "./selector";
import useEventListener from '@use-it/event-listener';
import { encryptionString } from '../../helpers/encryption';
import { randomString } from '../../helpers/randomString';
import { mapURL } from '../../helpers/domainURL';
import { getInstanceLogo } from '../Instance/instance';

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const validate = useValidation();
  const config = useConfiguration();
  const storage = useSessionStorage();
  const url = config.baseUrl;
  //const { isError, isSuccess, data, errorMessage, profileFlag, accountFlag } = useSelector(loginSelector);
  // const fiveStarDomain = ['emp5stardev.overturexl.com', 'qatestemployer5star.overturexl.com', '5staremployers.overturexl.com','5starstagingemployers.overturexl.com']
  // const isFiveStar = mapURL.fiveStarDomain.includes(window.location.hostname);
  // const lifeStyleDomain = ['dynamicemployers.overturexl.com']
  // const isLifeStyle = mapURL.lifeStyleDomain.includes(window.location.hostname);
  // const isNurseEtc = mapURL.nursesEtc.includes(window.location.hostname);
  const mainLogo = getInstanceLogo();
  useEffect(() => {
    document.title = 'Overture Employer Login';
  }, []);
  const [formData, setFormData] = useState({
    activationCode: '',
    email: '',
    password: '',
  });
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [passwordType, setPasswordType] = useState('password');
  const [iconStyleText, seticonStyleText] = useState(
    'zmdi zmdi-eye-off text-muted'
  );

  const [successMessage, setsuccessMessage] = useState(null);

  const togglePassword = () => {
    if (passwordType === 'password') {
      setPasswordType('text');
      seticonStyleText('zmdi zmdi-eye text-muted');
      return;
    }
    setPasswordType('password');
    seticonStyleText('zmdi zmdi-eye-off text-muted');
  };

  const [passwordTypeConfirm, setPasswordTypeConfirm] = useState('password');
  const [passwordInputConfirm, setPasswordInputConfirm] = useState('');
  const [iconStyleTextConfirm, seticonStyleTextConfirm] = useState(
    'zmdi zmdi-eye-off text-muted'
  );
  const handlePasswordChangeConfirm = (evnt) => {
    setPasswordInputConfirm(evnt.target.value);
  };
  const togglePasswordConfirm = () => {
    if (passwordTypeConfirm === 'password') {
      setPasswordTypeConfirm('text');
      seticonStyleTextConfirm('zmdi zmdi-eye text-muted');
      return;
    }
    setPasswordTypeConfirm('password');
    seticonStyleTextConfirm('zmdi zmdi-eye-off text-muted');
  };

  const [activationcodeType, setActivationCodeType] = useState('password');
  const [activationcode, setActivationcode] = useState('');
  const [iconStyleCodeConfirm, seticonStyleCodeConfirm] = useState(
    'zmdi zmdi-eye-off text-muted'
  );
  const handleActivationCode = (evnt) => {
    setActivationcode(evnt.target.value);
  };
  /* const toggleActivationCode = () => {
        if (activationcodeType === "password") {
            setActivationCodeType("text")
            seticonStyleCodeConfirm("zmdi zmdi-eye text-muted")
            return;
        }
        setActivationCodeType("password")
        seticonStyleCodeConfirm("zmdi zmdi-eye-off text-muted")
    } */

  const updateFormValue = (target) => {
    if (target.name === 'confirmPassword') {
      setConfirmNewPassword(target.value);
    } else {
      const { name, value } = target;
      setFormData({ ...formData, [name]: value });
    }
  };

  const validateForm = () => {
    const result = validate('register', [
      { name: 'email', data: formData.email },
      { name: 'newPassword', data: formData.password },
      { name: 'confirmNewPassword', data: confirmNewPassword },
      { name: 'activationCode', data: formData.activationCode },
    ]);
    if (result.valid) {
      setFormErrors({});
    } else {
      setFormErrors(result.errors);
    }
    return result.valid;
  };
  const customPasswordCheck = () => {
    if (formData.password && confirmNewPassword) {
      if (formData.password !== confirmNewPassword) {
        setFormErrors({
          confirmNewPassword: ['Password and Confirm Password must be same'],
        });
        return false;
      }
    }
    return true;
  };

  const registerEmployer = (event) => {
    event.preventDefault();
    if (validateForm() && customPasswordCheck()) {
      dispatch(setLoadingPageTrue());
      const iv = randomString(16, '0,1,2,3,4,5,6,7,8,9');
      requestUtil(`${url}/Authenticate/validate-and-add-employerV2`, 'POST', {
        activationCode: formData.activationCode,
        email: formData.email,
        ivKey: iv,
        encryptPassword: encryptionString(
          config.SaltKeyForJSandAPI,
          iv,
          formData.password
        ),
        userClientTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
      })
        .then((result) => {
          dispatch(setLoadingPageFalse());
          if (result && result.isEmailExist) {
            storage.setItem('login', result);
            setTimeout(() => {
              navigate('/addlocations', {
                state: {
                  email: formData.email,
                  password: formData.password,
                },
              });
            }, 500);
            setsuccessMessage(result.message);
            setErrorMessage();
          } else {
            setErrorMessage(result.message);
            setsuccessMessage();
          }
        })
        .catch((error) => {
          dispatch(setLoadingPageFalse());
          setErrorMessage(error.message);
        });
    }
  };

  const getLogin = (e) => {
    e.preventDefault();
    navigate('/');
  };
  return (
    <div>
      <Loader />
      <div className="page main-background-color">
        <div className="">
          <div className="container-login100">
            <div className="wrap-login100 p-6">
              <form className="login100-form needs-validation">
                <span className="login100-form-title pb-5">
                  <a href="">
                    <img
                    style={{minWidth:"270px", maxHeight:"90px", maxWidth:"280px" }}
                      // style={{ height: isFiveStar && "100px" }}
                      // src="assets/images/brand/Overturecommonlogo.svg"
                      src={mainLogo ? mainLogo :  "assets/images/brand/EMPLOYER.png"}
                      className="header-brand-img"
                      alt=""
                    />
                  </a>
                </span>
                <span className="login100-form-title pb-5">
                  Employer Register By Code
                </span>
                {errorMessage && (
                  <div class="alert alert-success" role="alert">
                    {errorMessage}
                  </div>
                )}
                {successMessage && (
                  <div class="alert alert-success" role="alert">
                    {successMessage}
                  </div>
                )}
                {/* {
                                    errorMessage &&
                                    <>
                                        <div
                                            className="toast wrap-input100 align-items-center text-white bg-danger border-0 show"
                                            role="alert" aria-live="assertive" aria-atomic="true"
                                            data-bs-autohide="false">
                                            <div className="logingerrormgs">
                                                <div className="toast-body">

                                                </div>
                                            </div>
                                        </div>
                                        <div>&nbsp;</div>
                                    </>
                                } */}
                <div className="panel panel-primary">
                  <div className="panel-body tabs-menu-body p-0 pt-5">
                    <div className="tab-content">
                      <div className="tab-pane active" id="tab5">
                        <TextField
                          placeholder={'Email'}
                          type={'email'}
                          name={'email'}
                          iconClass={'zmdi zmdi-email text-muted'}
                          updateValue={updateFormValue}
                          errors={formErrors['email']}
                        />

                        <TextField
                          placeholder={'Code Received via Email'}
                          iconClass={'zmdi zmdi-email text-muted'}
                          name={'activationCode'}
                          type={'text'}
                          updateValue={updateFormValue}
                          errors={formErrors['activationCode']}
                        />

                        <TextField
                          placeholder={'Password'}
                          clickeye={togglePassword}
                          type={passwordType}
                          name={'password'}
                          iconClass={iconStyleText}
                          updateValue={updateFormValue}
                          errors={formErrors['newPassword']}
                        />

                        <TextField
                          placeholder={'Confirm Password'}
                          clickeye={togglePasswordConfirm}
                          type={passwordTypeConfirm}
                          name={'confirmPassword'}
                          iconClass={iconStyleTextConfirm}
                          updateValue={updateFormValue}
                          errors={formErrors['confirmNewPassword']}
                        />

                        <div className="container-login100-form-btn">
                          <a
                            href="#"
                            className="login100-form-btn btn-primary"
                            onClick={registerEmployer}
                          >
                            Complete Registration
                          </a>
                        </div>
                        <div className="text-center pt-3">
                          <p className="text-dark mb-0">
                            Already a member?
                            <a
                              href="#"
                              onClick={getLogin}
                              className="text-primary ms-1"
                            >
                              Login
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
